import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { Dialog } from '@material-ui/core';
import GlobalTheme, { breakpointValues } from '../../../styled/GlobalTheme';
import GliderComponent from '../../../components/globals/GliderCarousel';
import {
  NextArrowIcon,
  BeforeArrowIcon,
} from '../../../assets/icons/iconRepository';
import mediaQueries from '../../../utils/mediaQueries';

const Container = styled.div`
  width: 330px;
  height: max-content;
  margin: 0 auto;
  @media ${mediaQueries.mdUp} {
    width: 650px;
    margin-top: 320px;
  }
  @media (max-width: 1366px) and (orientation: landscape) {
    margin-top: 230px;
  }
`;
const CustomDialog = styled(Dialog)`
  && {
    .MuiPaper-root {
      background: ${({ theme }) => theme.colors.secondary};
    }
  }
`;

const CustomGliderCarousel = styled(GliderComponent)`
  && {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .glider {
      &::-webkit-scrollbar {
        display: none;
      }
      @media (max-height: 425px) {
        height: 100%;
      }
    }
    button {
      pointer-events: auto;
    }
    .glider-next {
      margin-right: -22px;
      top: calc(50% - 20px);
      right: 51px !important;
      background-image: url(${NextArrowIcon});
      background-color: transparent;
      ${GlobalTheme.breakpoints.down('sm')} {
        margin-right: -40px;
      }
    }
    .glider-prev {
      margin-left: -22px;
      top: calc(50% - 20px);
      left: 51px !important;
      background-color: transparent;
      background-image: url(${BeforeArrowIcon});
      ${GlobalTheme.breakpoints.down('sm')} {
        margin-left: -40px;
      }
    }
    .glider-track {
      height: auto;
    }
    .glider-slide {
      grid-template-rows: auto 1fr 36px;
      @media ${mediaQueries.mdUp} {
        grid-template-rows: auto 1fr 46px;
      }
    }
    .glider-dots {
      position: absolute;
      bottom: 0;
      margin-left: auto;
      margin-right: auto;
      left: 0;
      right: 0;
      text-align: center;
      width: fit-content;
      .glider-dot {
        background: ${({ theme }) => theme.colors.secondary};
        border: 1px solid ${({ theme }) => theme.colors.grayMediaLibrary};
        @media ${mediaQueries.mdUp} {
          height: 14px;
          width: 14px;
        }
      }
      .active {
        background: ${({ theme }) => theme.colors.grayMediaLibrary};
      }
    }
  }
`;

const CarouselModal = ({
  sliders,
  open,
  header,
  footer,
  buttons,
}) => (
  <Media
    queries={{
      sm: `(max-width: ${breakpointValues.md - 1}px)`,
      md: `(max-width: ${breakpointValues.lgPlus}px)`,
      lg: `(min-width: ${breakpointValues.lgPlus + 1}px)`,
    }}
  >
    {(matches) => {
      let itemWidth = 650;
      if (matches.md) itemWidth = 650;
      if (matches.sm) itemWidth = 330;
      return (
        <CustomDialog
          fullScreen
          itemWidth={itemWidth}
          open={open}
        >
          {header}
          <Container itemWidth={itemWidth}>
            <CustomGliderCarousel
              hasArrows={false}
              hasDots
              settings={{
                itemWidth,
                exactWidth: true,
                slidesToShow: 1,
                slidesToScroll: 1,
              }}
            >
              {sliders.map((slider) => (
                <>{slider}</>
              ))}
            </CustomGliderCarousel>
          </Container>
          {buttons}
          {footer}
        </CustomDialog>
      );
    }}
  </Media>
);

CarouselModal.propTypes = {
  sliders: PropTypes.instanceOf(Array).isRequired,
  open: PropTypes.bool.isRequired,
  header: PropTypes.node.isRequired,
  footer: PropTypes.node.isRequired,
  buttons: PropTypes.node.isRequired,
};

export default CarouselModal;
